export default __webpack_public_path__ + "static/media/SLIDE_PARRA_8.956399ce.jpg";